import React, { useState, useEffect } from "react";
import { API } from "../backend";
import {
  Box,
  Button,
  Card,
  Container,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { useFlutterwave } from "flutterwave-react-v3";
// import Footer from "../../Component/Footer";
import axios from "axios";
import { Link, Navigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
// import Logo from '../../images/logo.png'
import ProceedModal from "../../Component/ProceedModal"; // will need to be changed to account for school ID i think
import { styled } from "@mui/system";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useRowSelect } from "react-table";
import { useSelector } from "react-redux";
import Layout from "../../reusables/layout/layout";
import LatePaymentFormCASBece from "../../Component/latepaymentform/latepayment_cas_bece";

const CustomTextField = styled(TextField)({
  "& .MuiInputBase-input.Mui-disabled": {
    color: "rgba(0,0,0,0.6) !important",
    "-webkit-text-fill-color": "rgba(0,0,0,0.6) !important",
    borderColor: "rgba(0,0,0,0.6) !important",
  },
});

const LatePaymentForm = () => {
  return (
    <Layout>
      <LatePaymentFormCASBece  examName='BECE'  examType='BECE Examination' lateRegistrationType="BECE Late Registration" />
    </Layout>
  );
};

export default LatePaymentForm;

// const user = useSelector(state => state.user.data)
// console.log(user)

// const [school, setSchool] = useState('')
// const [schoolId, setSchoolId] = useState('')
// const [schoolType, setSchoolType] = useState('')
// const [localGovt, setLocalGovt] = useState('')
// const [closing, setClosing] = useState('')
// const [name, setName] = useState('')
// const [email, setEmail] = useState('')
// const [phone, setPhone] = useState('')
// const [address, setAddress] = useState('')
// const [mda, setMda] = useState('')
// const [pinNum, setPinNum] = useState()
// const [totalPrice, setTotalPrice] = useState('')
// const [genInfo, setGenInfo] = useState([])
// const [open, setOpen] = useState(false);

// const handleClose = () => setOpen(false);

// const navigate = useNavigate()

// const handleSchoolType = async (e) => {
//     setSchoolType(e.target.value)
//     const schType = e.target.value
//     console.log(schType)
//     const response = await axios.get(`${API}typebece/${schType}/`)
//     console.log(response)
//     setGenInfo(response.data)
// }

// const handlePhone = e => {
//     const red = /^[0-9\b]+$/;
//     if (e.target.value === '' || red.test(e.target.value)) {
//         setPhone(e.target.value)
//     }
// }
// const handleAddress = e => {
//     setAddress(e.target.value)
// }

// const handleTotalPrice = e => {
//     setTotalPrice(e.target.value)
// }

// const handlepin = (e) => {
// const handleSchoolId = (e) => {
//     setSchoolId(e.target.value)
//     const schoolInfo = genInfo.filter(info => info.SchoolId === e.target.value)
//     console.log(schoolInfo)
//     // update the states
//     if (schoolInfo) {

//     }
//     else {
//         alert('fetching not successful')
//         setSchool('')
//         setLocalGovt('')
//         setName('')
//         setEmail('')
//         setPhone('')
//         setAddress('')
//     }
// }

// const updateData = async () => {
//     const obj = {
//         TotalPrice: 5000,
//         Mda: 'PAID',
//         ClosingDate: closing,
//         PayerName: name,
//         Payeremail: email,
//         Payerphone: phone

//     }
//     console.log(obj)

//     try {
//         const resp = await axios.put(`${API}beceannualcharges/${schoolId}/${schoolType}/`, obj);
//         console.log(resp)
//         if (resp.status === 200) {

//             setMda('')
//             setTotalPrice('')
//             setName('')
//             setEmail('')
//             setPhone('')

//             Swal.fire({
//                 title: 'Successful',
//                 text: `You have successfully pay for the late charge`,
//                 icon: 'success',
//                 confirmButtonText: 'Ok'
//             })

//             //some events that are meant to happen b4 redirection

//             //clear the localstorage
//             localStorage.removeItem("schoolType")
//             localStorage.removeItem("schoolId")
//             localStorage.removeItem("schoolName")
//             localStorage.removeItem("LgaName")
//             localStorage.removeItem("schoolTypeId")
//             localStorage.removeItem("LgaId")
//             localStorage.removeItem("payeremail")
//             localStorage.removeItem("PayerName")
//             localStorage.removeItem("Payerphone")
//             localStorage.removeItem("closingDate")

//             //get the updated data from the db
//             const response = await axios.get(`${API}typebece/${schoolType}/`)
//             console.log(response)
//             const res = response ? response.data : ''
//             console.log(res)

//             // filter out res
//             const inf = res.filter(info => info.SchoolId === schoolId)
//             console.log(inf)

//             // set states if inf exists
//             if (inf) {
//                 localStorage.setItem("schoolName", inf[0].SchoolName)
//                 localStorage.setItem("LgaName", inf[0].LgaName)
//                 localStorage.setItem("PayerName", inf[0].PayerName)
//                 localStorage.setItem("payeremail", inf[0].Payeremail)
//                 localStorage.setItem("payerphone", inf[0].Payerphone)
//                 localStorage.setItem("street", inf[0].Street)
//                 localStorage.setItem("LgaId", inf[0].LgaId)
//                 localStorage.setItem("schoolTypeId", inf[0].SchoolTypeId)
//                 localStorage.setItem("schoolType", inf[0].SchoolType)
//                 localStorage.setItem("schoolId", inf[0].SchoolId)
//                 localStorage.setItem("quota", inf[0].quota)
//                 localStorage.setItem("closingDate", inf[0].ClosingDate)
//                 // setSchool(schoolInfo ? schoolInfo[0].SchoolName : '')
//                 // setLocalGovt(schoolInfo ? schoolInfo[0].LgaName : '')
//                 // setName(schoolInfo ? schoolInfo[0].PayerName : '')
//                 // setEmail(schoolInfo ? schoolInfo[0].Payeremail : '')
//                 // setPhone(schoolInfo ? schoolInfo[0].Payerphone : '')
//                 // setAddress(schoolInfo ? schoolInfo[0].Street : '')
//                 // setClosing(schoolInfo ? schoolInfo[0].ClosingDate : '')
//                 // setLgaId(schoolInfo ? schoolInfo[0].LgaId : '')
//                 // setSchoolTypeId(schoolInfo ? schoolInfo[0].SchoolTypeId : '')

//             }

//             // set back to the localstorage.

//             navigate('/requisition/bece')

//             setOpen(true)
//             setPinNum('PAID')
//         }

//     } catch (err) {
//         console.error(err);
//     }
// }

// const config = {
//     public_key: process.env.REACT_APP_PUBLIC_KEY,
//     tx_ref: Date.now(),
//     amount: 5000,
//     currency: 'NGN',
//     payment_options: 'card,mobilemoney,ussd',
//     customer: {
//         email: email,
//         phonenumber: phone,

//     },
//     customizations: {
//         title: 'Lagos Pay',
//         description: 'PAYMENT FOR EXAMINATION (CBS)',
//         logo: 'https://pbs.twimg.com/media/EtEwgbvXMAQfCXT.jpg',
//     }
// }

// const handleFlutterPayment = useFlutterwave(config);

// const handlePayment = async () => {
//     handleFlutterPayment({
//         callback: (response) => {

//             if (response.status === "successful") {

//                 updateData()

//             }
//         },
//         onClose: () => { },
//     });
// }

// const handleClick = async (e) => {

//     e.preventDefault()

//     handlePayment()

// }
